import { render, staticRenderFns } from "./detailHeader1.vue?vue&type=template&id=7e607c11&"
import script from "./detailHeader1.vue?vue&type=script&lang=js&"
export * from "./detailHeader1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports